import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';
import googleMapStyle from '../utils/googleMapStyle';
import loadGoogleMaps from '../utils/loadGoogleMaps';

const Marker = () => <div className="profile-location__marker" aria-hidden="true" />;

const LocationSection = ({ lat, lng, location, mapOnly = false }) => {
  const parsedLat = parseFloat(lat);
  const parsedLng = parseFloat(lng);
  const hasCoords = Number.isFinite(parsedLat) && Number.isFinite(parsedLng);

  if (!hasCoords) {
    return null;
  }

  const center = { lat: parsedLat, lng: parsedLng };

  const map = (
    <div className="profile-location__mapWrap">
      <div className="profile-location__map">
        <GoogleMapReact
          options={{ styles: googleMapStyle }}
          googleMapLoader={loadGoogleMaps}
          defaultCenter={center}
          center={center}
          defaultZoom={11}
          zoom={11}
          draggable={false}
        >
          <Marker lat={parsedLat} lng={parsedLng} />
        </GoogleMapReact>
      </div>
    </div>
  );

  if (mapOnly) {
    return map;
  }

  return (
    <section className="profile-location">
      <header className="profile-location__header">
        <div className="profile-location__titleRow">
          <span className="profile-location__iconCircle" aria-hidden="true">
            <Icon name="map-marker" size={20} color={primitives.violet['700']} />
          </span>
          <h2 className="profile-location__title">{location || 'Location'}</h2>
        </div>
      </header>

      {map}
    </section>
  );
};

LocationSection.propTypes = {
  lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  location: PropTypes.string,
  mapOnly: PropTypes.bool,
};

export default LocationSection;
